export default "__VITE_ASSET__3a316115__"